import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "../../lib/auth";
import api, { formatApiError } from "../../lib/api";
import { toast, Toaster } from "sonner";

export default function AgenziaFirstLogin() {
  const { user, agency, loading, logout, refreshMe } = useAuth();
  const nav = useNavigate();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  if (loading) return <div className="p-10 text-center text-[#5C5657]">Caricamento…</div>;
  if (!user || localStorage.getItem("rxcasa_role") !== "agency") return <Navigate to="/area-agenzie/login" replace />;
  // Se non serve più cambiare password, torna alla dashboard
  if (!user.must_change_password) return <Navigate to="/area-agenzie" replace />;

  const submit = async (e) => {
    e.preventDefault();
    if (next.length < 8) { toast.error("La nuova password deve avere almeno 8 caratteri"); return; }
    if (next !== confirm) { toast.error("Le due password non coincidono"); return; }
    if (next === current) { toast.error("La nuova password deve essere diversa da quella iniziale"); return; }
    setBusy(true);
    try {
      await api.post("/agency/me/password", { current_password: current, new_password: next });
      await refreshMe();
      toast.success("Password aggiornata. Benvenuti.");
      nav("/area-agenzie", { replace: true });
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Errore cambio password");
    } finally { setBusy(false); }
  };

  const onLogout = async () => { await logout(); nav("/area-agenzie/login"); };

  return (
    <div className="min-h-screen paper-bg flex items-center justify-center p-8" data-testid="agenzia-first-login">
      <Toaster position="top-right" richColors />
      <div className="w-full max-w-lg bg-white border border-[#E6E4E0] p-10">
        <div className="label-uppercase text-[#7D2E3F]">Primo accesso · {agency?.name}</div>
        <h1 className="font-serif text-3xl mt-2 mb-3">Scegli la tua password</h1>
        <p className="text-sm text-[#5C5657] mb-8 leading-relaxed">
          Ciao <strong>{user.name}</strong>, per proteggere il tuo accesso ti chiediamo di scegliere subito
          una password personale, diversa da quella iniziale ricevuta via email. Solo tu la conoscerai.
        </p>
        <form onSubmit={submit} className="space-y-5">
          <div>
            <label className="label-uppercase">Password iniziale (ricevuta via email)</label>
            <input required type="password" minLength={8} value={current}
                   data-testid="first-login-current"
                   onChange={(e) => setCurrent(e.target.value)}
                   className="editorial-input" autoComplete="current-password" autoFocus />
          </div>
          <div>
            <label className="label-uppercase">Nuova password</label>
            <input required type="password" minLength={8} value={next}
                   data-testid="first-login-new"
                   onChange={(e) => setNext(e.target.value)}
                   className="editorial-input" autoComplete="new-password"
                   placeholder="Almeno 8 caratteri" />
          </div>
          <div>
            <label className="label-uppercase">Conferma nuova password</label>
            <input required type="password" minLength={8} value={confirm}
                   data-testid="first-login-confirm"
                   onChange={(e) => setConfirm(e.target.value)}
                   className="editorial-input" autoComplete="new-password" />
          </div>
          <button type="submit" disabled={busy} data-testid="first-login-submit" className="btn-primary w-full">
            {busy ? "Salvo…" : "Imposta password e continua"}
          </button>
          <button type="button" onClick={onLogout}
                  data-testid="first-login-logout"
                  className="block w-full text-xs text-center text-[#5C5657] hover:text-[#7D2E3F]">
            Esci senza continuare
          </button>
        </form>
      </div>
    </div>
  );
}
